import { signupFormWithAnalyticsSchema } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import * as z from "zod";

export const getSignupFormById = {
  name: "getSignupFormById" as const,
  input: z.object({ formId: z.string() }),
  output: signupFormWithAnalyticsSchema,
};
